import React, { forwardRef } from 'react';
import './crm-ui.scss';

const CrmButton = forwardRef(({
  children,
  variant = 'secondary',
  size = 'default',
  startIcon,
  endIcon,
  loading = false,
  disabled = false,
  iconOnly = false,
  className = '',
  type = 'button',
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    className={[
      'crm-button',
      `crm-button--${variant}`,
      `crm-button--${size}`,
      iconOnly ? 'crm-button--icon-only' : '',
      className,
    ].filter(Boolean).join(' ')}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    {...props}
  >
    {loading ? <span className="crm-button__spinner" aria-hidden="true" /> : startIcon}
    {!iconOnly || children ? <span className="crm-button__label">{children}</span> : null}
    {!loading ? endIcon : null}
  </button>
));

CrmButton.displayName = 'CrmButton';

export default CrmButton;
